import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'doc-self-report',
  templateUrl: './doc-self-report.component.html',
  styleUrls: ['./doc-self-report.component.css']
})
export class DocSelfReportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
